import { render, staticRenderFns } from "./EditSubRoomPopup.vue?vue&type=template&id=20792d3c&scoped=true"
import script from "./EditSubRoomPopup.vue?vue&type=script&lang=ts"
export * from "./EditSubRoomPopup.vue?vue&type=script&lang=ts"
import style0 from "./EditSubRoomPopup.vue?vue&type=style&index=0&id=20792d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20792d3c",
  null
  
)

export default component.exports